import { useAuth } from "react-oidc-context";
import { parseJwt } from "./TokenUtils";

export function useAuthExt() {
    const realm = "FlightReports";
    const auth = useAuth();

    const hasPermission = (permission: string): boolean => {
        if (!auth.user || !auth.user.access_token) {
            return false;
        }
        const jwtUser = parseJwt(auth.user?.access_token);
        if (!jwtUser) return false;
        return jwtUser.resourceRoles[realm]?.includes(permission) ?? false;
    };
    const hasAnyPermission = (permissions: string[]): boolean => {
        if (!auth.user || !auth.user.access_token) {
            return false;
        }
        const jwtUser = parseJwt(auth.user?.access_token);
        if (!jwtUser) return false;
        const roles = jwtUser.resourceRoles[realm] ?? [];
        return permissions.some((permission) => roles.includes(permission));
    };

    const hasAnyPermissionInAnyRealm = (permissions: string[]): boolean => {
        if (!auth.user || !auth.user.access_token) {
            return false;
        }

        const jwtUser = parseJwt(auth.user.access_token);
        if (!jwtUser || !jwtUser.resourceRoles) {
            return false;
        }

        for (const realm in jwtUser.resourceRoles) {
            const roles = jwtUser.resourceRoles[realm] ?? [];
            if (permissions.some((permission) => roles.includes(permission))) {
                return true;
            }
        }

        return false;
    };

    return {
        ...auth,
        hasPermission,
        hasAnyPermission,
        hasAnyPermissionInAnyRealm,
    };
}
